// src/components/BoardPack/pages/kpi_enforcement_table.jsx
import React, { useState, useEffect, useRef } from "react";
import { apiCall } from "@/api/apiCall";
import KPIMonthlyPerformanceTable from "../components/tables/KPIMonthlyPerformanceTable";
import LoadingComponent from "@/components/common/LoadingComponent";
import ErrorState from "@/components/common/ErrorStateComponent";
import { useQueue } from "@/context/QueueContext";
import { processParams } from "../utils/paramsHelper";
import { useNavigate } from "react-router-dom";

const KpiEnforcementTable = ({ year = "", month = "", monthNumber = "", contract = "", page = null,isRefresh = false }) => {
    const { enqueue } = useQueue();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [tableData, setTableData] = useState({ years: [], rows: [], month: "" });
        const hasFetchedRef = useRef(false);
    

    useEffect(() => {
      if (!year || !month || !contract) return;
      if (hasFetchedRef.current) return;
    
      hasFetchedRef.current = true;
      fetchKPIData();
    }, [year, month, contract]);
       const fetchKPIData = async () => {
            try {
                setLoading(true);
                setError(null);
const apiParams = processParams(page?.params || {}, { year, month, contract });

                const response = await enqueue(() => apiCall(
                    "GET",
                    "/boardpack/enforcement-monthly-kpi",
                    apiParams,
                    navigate,
                false,
                false,
                isRefresh
                ));

                if (!response?.success) {
                    throw new Error(response?.message || "API returned unsuccessful response");
                }

                if (response?.success && response?.data && response?.meta) {
                    const { data, meta } = response;
                    const { years, month } = meta;

                    // Get unique columns from the first year's first metric
                    const firstMetric = Object.keys(data)[0];
                    const firstYear = years[0].toString();
                    const columns = Object.keys(data[firstMetric][firstYear][month]);

                    // Build year structure dynamically
                    const yearStructure = years.map(year => ({
                        year: year.toString(),
                        columns: columns
                    }));

                    // Transform data to rows
                    const transformedRows = Object.keys(data).map(metricKey => {
                        const metricData = data[metricKey];
                        const label = metricKey.replace(/_/g, ' ').replace(/\\/g, '/');

                        const values = [];
                        years.forEach(year => {
                            const yearStr = year.toString();
                            const monthData = metricData[yearStr]?.[month] || {};
                            columns.forEach(col => {
                                values.push(monthData[col] || "-");
                            });
                        });

                        return { label, values };
                    });

                    setTableData({
                        years: yearStructure,
                        rows: transformedRows,
                        month: month
                    });
                }
            } catch (err) {
                console.error("KPI fetch error:", err);
                setError(err.message || "Failed to load data. Please try again later.");
            } finally {
                setLoading(false);
            }
        };

         if (loading) {
    return <LoadingComponent />;
  }

  if (error) {
    return <ErrorState error={error} onRetry={fetchKPIData} />;
  }

    return (
        <KPIMonthlyPerformanceTable
            tableData={tableData}
            loading={loading}
            error={error}
            page={page}
        />
    );
};

export default KpiEnforcementTable;